import { Component } from '@angular/core';

@Component({
    selector: 'cipo-typography',
    imports: [],
    templateUrl: './typography.component.html'
})
export class DemoTypographyComponent {}
